// enabled only for production builds: dev (yarn serve) and test (the e2e
// suite in e2e/, which runs the real signup flow via Playwright) must never
// post into the live project, and gating on NODE_ENV does that for every
// non-prod mode at once instead of per env file
const config = {
  enabled: import.meta.env.PROD,
  key: "phc_qPDXUAABRL4JkdDewLzzXZw3bvJ763Y78nxYC84jUrEd",
  host: "https://eu.i.posthog.com",
};

export default config;
